import React from 'react';
import PropTypes from 'prop-types';
import './Modal.scss';

import Mask from '../Mask/Mask.jsx';

function Modal(props) {
    let content = null;
    if (!props.closed) {
        const classes = ['r-modal'];
        if (props.size) {
            classes.push(`r-modal--${props.size}`);
        }
        content = (
            <React.Fragment>
                <Mask onClick={props.onClose} />
                <div className={classes.join(' ')}>
                    <div className='r-modal__content'>
                        {props.title ? (
                            <h2 className='r-modal__title'>{props.title}</h2>
                        ) : null}

                        {props.children}
                    </div>
                </div>
            </React.Fragment>
        );
    }
    return content;
}

Modal.propTypes = {};
Modal.defaultProps = {};

export default Modal;
